import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {

  return <Route {...rest} render={(routeProps) => (localStorage.getItem("userID") ? <RouteComponent {...routeProps} /> : <Redirect to={{ pathname: "/" }} />)} />;
};

export default PrivateRoute;
